import * as ConfigTypes from 'config/ConfigTypes';
import { getDialogConfig } from "helpers/ConfigHelper";
import { isMetaValid } from 'helpers/MetadataHelper';
import SortHelper from "helpers/SortHelper";
import { subAfter } from 'helpers/TypeHelper';

export const getTokenDuration = () => {
    const storedDate = localStorage.getItem('expiration');
    const expirationDate = new Date(storedDate);
    const now = new Date();
    return expirationDate.getTime() - now.getTime();
}

export const getAuthToken = () => {
    const token = localStorage.getItem('token');
    if (!token) return null;
    const tokenDur = getTokenDuration();
    if (tokenDur < 0) {
        //return ConfigTypes.EXPIRED;
        return false;
    }
    return token;
}

export const clearStorage = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('expiration');
    localStorage.removeItem('cartObjects');
    localStorage.removeItem('user');
    window.location.reload();
}

export const getDiffInvoiceAddr = ({ configObjects, dialogMode, configName }) => {
    let fields = getDialogConfig({ dialogMode, configObjects, configName });
    return fields;
}

export const getDiffDeliveryAddr = ({ configObjects, dialogMode, configName }) => {
    let fields = getDialogConfig({ dialogMode, configObjects, configName });
    return fields;
}

export const getMailings = ({ configObjects }) => {
    let mailings = getDialogConfig({
        dialogMode: ConfigTypes.SUB_MAILINGS,
        configObjects, configName: "userconfig"
    });
    return mailings;
}

export const addMailings = ({ fields, configObjects }) => {
    let subscribeMailings = getMailings({ configObjects });
    let breakline = ConfigTypes.BREAKLINE_OBJ;
    let heading = { name: 'subscribe_mailings', intl: "data.auth.subscribe_mailings", type: "info", order: 20 };
    let protectData = [...ConfigTypes.ACCEPT_PROTECTION_DATA];
    let mailings = {
        name: 'subscribe_mailings', intl: "data.auth.subscribe_mailings", type: ConfigTypes.SPLIT, order: 21,
        children: [
            { name: 'part1', children: subscribeMailings },
            { name: 'part2', children: protectData, htmlClasses: "registerform-large" }
        ]
    };
    return [...fields, breakline, heading, mailings];
}

export const getMailingsData = ({ configObjects, authObjects }) => {
    let fields;
    let dialogMode = ConfigTypes.REGISTER_OVERVIEW;
    let mailingsObj = { name: "mailingObj", intl: "data.auth.mailings", type: ConfigTypes.LIST_DATA, data: [] };
    if (authObjects && authObjects[dialogMode]) {
        fields = getMailings({ configObjects });
        if (fields && fields.length > 0) {
            fields.forEach(item => {
                if (item.field && authObjects[dialogMode][item.field]) {
                    mailingsObj.data.push(item);
                }
            });
        }
    }
    if (mailingsObj.data && mailingsObj.data.length > 0) return mailingsObj
    return null;
}

export const getAcceptData = ({ configObjects, authObjects }) => {
    let fields = [];
    let dialogMode = ConfigTypes.REGISTER_OVERVIEW;
    if (authObjects && authObjects[dialogMode]) {
        let data = [...ConfigTypes.ACCEPT_PROTECTION_DATA];
        if (data && data.length > 0) {
            data.forEach(item => {
                if (item.field && authObjects[dialogMode][item.field]) {
                    fields.push({ ...item, type: item.displayType });
                }
                else if (item.name === ConfigTypes.BREAKLINE) fields.push(item);
            });
        }
    }
    if (fields && fields.length > 0) {
        fields = SortHelper.sortByValue({ data: fields, sorted: "asc", field: "displayOrder", isNumber: true });
        return fields;
    }
    return null;
}

export const changeTypeForDisplay = ({ fields, addrObj }) => {
    if (fields && fields.length > 0) {
        fields = fields.map(item => {
            if (item.children && item.children.length > 0) {
                item.children = item.children.map(el => {
                    el.type = ConfigTypes.TEXT;
                    if (el.displayType) el.type = el.displayType;
                    return el;
                })
            }
            return { ...item, type: ConfigTypes.TEXT }
        });
        fields.unshift(addrObj);
    }
    return fields;
}

export const canGetData = ({ authObjects }) => {
    if (authObjects && authObjects.prevAuthForm
        && (authObjects.prevAuthForm === ConfigTypes.REGISTER_USER_DIFF_DELIVERY_ADDR
            || authObjects.prevAuthForm === ConfigTypes.REGISTER_USER
            || authObjects.prevAuthForm === ConfigTypes.REGISTER_USER_DIFF_INVOICE_ADDR
        )) {
        return true;
    }
    return false;
}

export const getDiffDeliveryAddrItems = ({ configObjects, authObjects }) => {
    let fields;
    let dialogMode = ConfigTypes.REGISTER_INST_DIFF_DELIVERY_ADDR;
    let configName = "instconfig";
    let addrObj = ConfigTypes.INST_DIFF_DELIVERY_ADD_OBJ;
    if (canGetData({ authObjects })) {
        dialogMode = ConfigTypes.REGISTER_USER_DIFF_DELIVERY_ADDR;
        configName = "userconfig";
        addrObj = ConfigTypes.USER_DIFF_DELIVERY_ADD_OBJ;
    }
    if (authObjects && authObjects[dialogMode]) {
        fields = getDiffDeliveryAddr({ configObjects, dialogMode, configName });
        fields = changeTypeForDisplay({ fields, addrObj })
    }
    //console.log("LOGS: LAMTEST getDiffDeliveryAddrItems fields", fields);
    return fields;
}

export const getDiffInvoiceAddrItems = ({ configObjects, authObjects }) => {
    let fields;
    let dialogMode = ConfigTypes.REGISTER_INST_DIFF_INVOICE_ADDR;
    let configName = "instconfig";
    let addrObj = ConfigTypes.INST_DIFF_INVOICE_ADD_OBJ;
    if (canGetData({ authObjects })) {
        dialogMode = ConfigTypes.REGISTER_USER_DIFF_INVOICE_ADDR;
        configName = "userconfig";
        addrObj = ConfigTypes.USER_DIFF_INVOICE_ADD_OBJ;
    }
    if (authObjects && authObjects[dialogMode]) {
        fields = getDiffInvoiceAddr({ configObjects, dialogMode, configName });
        fields = changeTypeForDisplay({ fields, addrObj })
    }
    //console.log("LOGS: LAMTEST getDiffInvoiceAddrItems fields", fields);
    return fields;
}

export const getUserItems = ({ configObjects }) => {
    let fields = getDialogConfig({
        dialogMode: ConfigTypes.REGISTER_USER,
        configObjects, configName: "userconfig"
    });
    fields = [...fields, ...ConfigTypes.USER_BUTTONS];
    //console.log("LOGS: LAMTEST getUserItem fields", fields);
    return fields;
}

export const getInstitutionItems = ({ configObjects }) => {
    let fields = getDialogConfig({
        dialogMode: ConfigTypes.REGISTER_INST,
        configObjects, configName: "instconfig"
    });
    fields.push(ConfigTypes.INST_PERMISSION_OBJ);
    fields.push(ConfigTypes.BREAKLINE_RED_OBJ);
    if (fields && fields.length) {
        if (fields[0] && fields[0].children) {
            fields[0].children.push(ConfigTypes.NEW_INSTITUTION_BTN);
        }
    }
    let userFields = getDialogConfig({
        dialogMode: ConfigTypes.REGISTER_INST,
        configObjects, configName: "userconfig"
    });
    fields = [...fields, ...userFields];
    console.log("LOGS: getInstitutionItems fields", fields);
    return fields;
}

export const getNewInstitutionItems = ({ configObjects }) => {
    let instFields = getDialogConfig({
        dialogMode: ConfigTypes.REGISTER_NEW_INST,
        configObjects, configName: "instconfig"
    });
    let userFields = getDialogConfig({
        dialogMode: ConfigTypes.REGISTER_NEW_INST,
        configObjects, configName: "userconfig"
    });
    let fields = [...instFields, ConfigTypes.RED_BREAKLINE,
    ConfigTypes.INST_PERMISSION_OBJ, ...userFields];
    console.log("LOGS: getNewInstitutionItems fields", fields);
    return fields;
}

export const getCreateInstitutionItems = ({ configObjects }) => {
    let instFields = getDialogConfig({
        dialogMode: ConfigTypes.REGISTER_CREATE_INST,
        configObjects, configName: "instconfig"
    });

    let fields = [...instFields, ConfigTypes.INST_MEMBER_FIAF_OBJ,
    ...ConfigTypes.INSTITUTION_BUTTONS];
    console.log("LOGS: getCreateInstitutionItems fields", fields);
    return fields;
}

export const isValidPassword = ({userInputs, entry}) => {
    let password = userInputs[entry.field]
    if(password){
        // at least 8 characters, including uppercase and lowercase letters and numbers
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
        return regex.test(password);
    }
    return false;
}


export const verifyFields = ({ userInputs, authForm, configObjects, configInputs = null }) => {
    let noErrors = true;
    let res = {};
    if (!configInputs) configInputs = getAuthFormData({ authForm, configObjects });
    if (authForm === ConfigTypes.REGISTER_OVERVIEW) {
        configInputs = [...ConfigTypes.ACCEPT_PROTECTION_DATA];
    }
    if (configInputs && configInputs.length > 0) {
        configInputs.forEach(item => {
            if (item.required && item.type == ConfigTypes.INPUT_DEPENDS_ON_DD) {
                if (item.data && item.data.length) {
                    if (!item.data.some(el => userInputs[el])) {
                        noErrors = false;
                        res[item.name] = ConfigTypes.EMPTY;
                    }
                }
            }
            else if (item.children && item.children.length > 0) {
                item.children.forEach(el => {
                    if (el.required && !isMetaValid({ userInputs, entry: el })) {
                        noErrors = false;
                        res[el.name] = ConfigTypes.EMPTY;
                    }
                })
            } else if (item.required && !isMetaValid({ userInputs, entry: item })) {
                if (item.check && userInputs[item.check.field]) {
                    console.log("LOGS: checkField", item.check);
                } else {
                    noErrors = false;
                    res[item.name] = ConfigTypes.EMPTY;
                }
            } else if(item.type == ConfigTypes.PASSWORD && !isValidPassword({userInputs, entry: item}) && !item.notVertify){
                noErrors = false;
                res[item.name] = ConfigTypes.EMPTY;
            } else if (item.field && item.field.startsWith(ConfigTypes.ONLY_REPEAT)) {
                let compareFi = subAfter(item.field, ConfigTypes.ONLY_REPEAT);
                if (userInputs[compareFi] && userInputs[item.field]
                    && userInputs[compareFi] !== userInputs[item.field]) {
                    noErrors = false;
                    res[item.name] = ConfigTypes.NOT_MATCHED;
                }
            } 
        })
    }
    return { noErrors, ...res };
}

export const checkParentsForm = ({ configObjects, authObjects, parentsForm }) => {
    let userInputs = authObjects[`${parentsForm}`] || {};
    const res = verifyFields({ userInputs, authForm: parentsForm, configObjects });
    if (res && res.noErrors) {
        return ConfigTypes.REGISTER_OVERVIEW;
    }
    return parentsForm;
}

export const getFormHeading = ({ authForm, formatMessage }) => {
    switch (authForm) {
        case ConfigTypes.REGISTER_USER:
            return <div>{formatMessage({ id: "data.auth.registerasfreelancer" })}</div>;
        case ConfigTypes.REGISTER_INST:
            return (
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <div>{formatMessage({ id: "data.auth.registerasinstitutions" })}</div>
                </div>
            );
        case ConfigTypes.REGISTER_NEW_INST:
            return (
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <div>{formatMessage({ id: "data.auth.registerasnewinstitutions" })}</div>
                </div>
            );
        case ConfigTypes.REGISTER_CREATE_INST:
            return (
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <div>{formatMessage({ id: "data.auth.createinstitution" })}</div>
                </div>
            );
        case ConfigTypes.REGISTER_INST_DIFF_INVOICE_ADDR:
        case ConfigTypes.REGISTER_USER_DIFF_INVOICE_ADDR:
            return <h1>{formatMessage({ id: "data.auth.diffinvoiceaddr" })}</h1>;
        case ConfigTypes.REGISTER_INST_DIFF_DELIVERY_ADDR:
        case ConfigTypes.REGISTER_USER_DIFF_DELIVERY_ADDR:
            return <h1>{formatMessage({ id: "data.auth.diffdeliveryaddr" })}</h1>;
        case ConfigTypes.REGISTER_OVERVIEW:
            return <div>{formatMessage({ id: "data.auth.overview" })}</div>;
        case ConfigTypes.FILL_USER:
            return <div>{formatMessage({ id: "data.auth.fillIn" })}</div>
        default:
            return "";
    }
}

export const getAuthFormData = ({ authForm, configObjects, authObjects }) => {

    switch (authForm) {
        case ConfigTypes.LOGIN:
            return ConfigTypes.LOGIN_ITEMS;
        case ConfigTypes.REGISTER_USER:
            return getUserItems({ configObjects });
        case ConfigTypes.REGISTER_INST:
            return getInstitutionItems({ configObjects });
        case ConfigTypes.REGISTER_NEW_INST:
            return getNewInstitutionItems({ configObjects });
        case ConfigTypes.REGISTER_CREATE_INST:
            return getCreateInstitutionItems({ configObjects });
        case ConfigTypes.REGISTER_INST_DIFF_INVOICE_ADDR:
            return getDiffInvoiceAddr({ configObjects, dialogMode: authForm, configName: "instconfig" });
        case ConfigTypes.REGISTER_INST_DIFF_DELIVERY_ADDR:
            return getDiffDeliveryAddr({ configObjects, dialogMode: authForm, configName: "instconfig" });
        case ConfigTypes.REGISTER_USER_DIFF_INVOICE_ADDR:
            return getDiffInvoiceAddr({ configObjects, dialogMode: authForm, configName: "userconfig" });
        case ConfigTypes.REGISTER_USER_DIFF_DELIVERY_ADDR:
            return getDiffDeliveryAddr({ configObjects, dialogMode: authForm, configName: "userconfig" });
        case ConfigTypes.REGISTER_OVERVIEW:
            return getOverviewItems({ configObjects, authObjects });
        case ConfigTypes.REGISTER_APPLY:
            return getApplyItems({ configObjects, authObjects });
        default:
            return [];
    }
}

export const handleActionBack = ({ authForm, prevAuthForm }) => {
    switch (authForm) {
        case ConfigTypes.REGISTER_USER:
        case ConfigTypes.REGISTER_INST:
            return ConfigTypes.ACCEPT;
        case ConfigTypes.REGISTER_NEW_INST:
            return ConfigTypes.REGISTER_INST;
        case ConfigTypes.REGISTER_CREATE_INST:
            return ConfigTypes.REGISTER_INST;
        case ConfigTypes.REGISTER_INST_DIFF_INVOICE_ADDR:
        case ConfigTypes.REGISTER_INST_DIFF_DELIVERY_ADDR:
            return ConfigTypes.REGISTER_NEW_INST;
        case ConfigTypes.REGISTER_USER_DIFF_INVOICE_ADDR:
        case ConfigTypes.REGISTER_USER_DIFF_DELIVERY_ADDR:
            return ConfigTypes.REGISTER_USER;
        case ConfigTypes.REGISTER_OVERVIEW:
            return prevAuthForm;
        default:
            return;
    }
}

export const handleActionNext = ({ authForm, configObjects, authObjects }) => {
    switch (authForm) {
        case ConfigTypes.REGISTER_USER:
        case ConfigTypes.REGISTER_INST:
        case ConfigTypes.REGISTER_NEW_INST:
            return ConfigTypes.REGISTER_OVERVIEW;
        case ConfigTypes.REGISTER_CREATE_INST:
            return ConfigTypes.REGISTER_NEW_INST;
        case ConfigTypes.REGISTER_INST_DIFF_INVOICE_ADDR:
        case ConfigTypes.REGISTER_INST_DIFF_DELIVERY_ADDR:
            return checkParentsForm({ configObjects, authObjects, parentsForm: ConfigTypes.REGISTER_INST });
        case ConfigTypes.REGISTER_USER_DIFF_INVOICE_ADDR:
        case ConfigTypes.REGISTER_USER_DIFF_DELIVERY_ADDR:
            return checkParentsForm({ configObjects, authObjects, parentsForm: ConfigTypes.REGISTER_USER });
        case ConfigTypes.REGISTER_OVERVIEW:
            return ConfigTypes.REGISTER_APPLY;
        default:
            return;
    }
}

export const handleActionsBottomBtn = ({ authForm }) => {
    switch (authForm) {
        case ConfigTypes.REGISTER_APPLY:
            return null;
        case ConfigTypes.REGISTER_OVERVIEW:
            return ConfigTypes.REGISTER_OVERVIEW_ACTIONS;
        case ConfigTypes.REGISTER_CREATE_INST:
            return ConfigTypes.REGISTER_CREATE_ACTIONS;
        case ConfigTypes.FILL_USER:
            return ConfigTypes.FILL_ACTIONS;
        default:
            return ConfigTypes.REGISTER_ACTIONS;
    }
}

export const getAllDiffAddr = ({ fields, configObjects, authObjects }) => {
    let breakline = ConfigTypes.BREAKLINE_OBJ;
    let diffDeliveryAddrItems = getDiffDeliveryAddrItems({ configObjects, authObjects });
    if (diffDeliveryAddrItems && diffDeliveryAddrItems.length > 0) {
        fields = [...fields, breakline, ...diffDeliveryAddrItems];
    }

    let diffInvoiceAddrItems = getDiffInvoiceAddrItems({ configObjects, authObjects });
    if (diffInvoiceAddrItems && diffInvoiceAddrItems.length > 0) {
        fields = [...fields, breakline, ...diffInvoiceAddrItems];
    }
    fields = fields.map(item => {
        if (item.children) item.type = ConfigTypes.TEXT_FROM_CHILDREN;
        return item;
    });
    return fields;
}

export const getOverviewItems = ({ configObjects, authObjects }) => {
    let fields = [];
    let dialogMode = ConfigTypes.REGISTER_OVERVIEW;
    let isInst = false;
    if (authObjects && authObjects.registerAs === ConfigTypes.REGISTER_INST) {
        dialogMode = "register_inst_overview";
        isInst = true;
    }
    let userFields = getDialogConfig({ dialogMode, configObjects, configName: "userconfig" });
    fields = [...userFields];
    if (isInst) {
        let instFields = getDialogConfig({ dialogMode, configObjects, configName: "instconfig" });
        fields = [...fields, ...instFields];
    }
    fields = getAllDiffAddr({ fields, configObjects, authObjects });
    fields = addMailings({ fields, configObjects });
    //console.log("LOGS: LAMTEST getOverviewItems", fields);
    return fields;
}

export const getApplyItems = ({ configObjects, authObjects }) => {
    let fields = [];
    let breakline = ConfigTypes.BREAKLINE_OBJ;
    let dialogMode = ConfigTypes.REGISTER_APPLY;
    let isInst = false;
    if (authObjects && authObjects.registerAs === ConfigTypes.REGISTER_INST) {
        dialogMode = "register_inst_apply";
        isInst = true;
    }
    let userFields = getDialogConfig({ dialogMode, configObjects, configName: "userconfig" });
    fields = [...userFields];
    if (isInst) {
        let instFields = getDialogConfig({ dialogMode, configObjects, configName: "instconfig" });
        fields = [...fields, ...instFields];
    }
    fields = [ConfigTypes.APPLY_INFO_OBJ, breakline, ...fields];
    fields = getAllDiffAddr({ fields, configObjects, authObjects });
    let mailingsObj = getMailingsData({ configObjects, authObjects });
    if (mailingsObj) {
        fields.push(breakline);
        fields.push(mailingsObj);
    }
    let acceptData = getAcceptData({ configObjects, authObjects });
    if (acceptData) fields = [...fields, ...acceptData];
    //console.log("LOGS: LAMTEST getApplyItems", fields);
    return fields;
}

export const handlePwMsg = ({ msg, formatMessage }) => {
    switch (msg) {
        case ConfigTypes.MAIL_NOT_FOUND:
            return formatMessage({ id: "auth.mailnotfound.msg" });
        case ConfigTypes.SENDING_RESET_MAIL:
            return formatMessage({ id: "auth.sendingresetmail.msg" });
        default:
            return msg;
    }
}
